module.exports = __webpack_public_path__ + "media/images/flags/32/Cape-Verde-ff8f6fda542746bc24cfc5819302e5cb.png";